var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home"},[_c('img',{staticClass:"home-logo",attrs:{"alt":"app logo","src":require("../assets/images/logo-inverted.svg")}}),_c('Index',{attrs:{"title":"Ben Schreiber","subtitle":"musician / artist / developer"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }